/**
 * Verifica se o canal de venda é Americanas
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const salesChannelIsAmericanas = (canalDeVenda) => {
  const allowedSaleChannels = ['americanas', 'vtex'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}

/**
 * Verifica se o canal de venda é marketplace out
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const salesChannelIsMarketplaceOut = (canalDeVenda) => {
  const allowedSaleChannels = ['ifood', 'magalu', '99food', 'rappi', 'shopee'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}

/**
 * Verifica se o canal de venda é Magazine Luiza
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const salesChannelIsMagalu = (canalDeVenda) => {
  const allowedSaleChannels = ['magalu'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}

/**
 * Verifica se o canal de venda é iFood
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const salesChannelIsIfood = (canalDeVenda) => {
  const allowedSaleChannels = ['ifood'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}

/**
 * Verifica se o canal de venda é 99Food
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const salesChannelIs99food = (canalDeVenda) => {
  const allowedSaleChannels = ['99food'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}

/**
 * Verifica se o canal de venda é Rappi
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const salesChannelIsRappi = (canalDeVenda) => {
  const allowedSaleChannels = ['rappi'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}

/**
 * Verifica se o canal de venda é Shopee
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const salesChannelIsShopee = (canalDeVenda) => {
  const allowedSaleChannels = ['shopee'];

  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
}

/**
 * Verifica se a devolução é permitida para o canal de venda.
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const isDevolutionAllowedForSalesChannel = (canalDeVenda, allowedSaleChannels = ['magalu', 'shopee', 'rappi', 'ifood']) => {
  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
};

/**
 * Verifica os canais de venda em que o motoboy não pode devolver o pedido.
 * 
 * @param {string} canalDeVenda
 *  
 * @returns {bool} 
 */
export const isDeliverymanBackBlockedForSalesChannel = (canalDeVenda, allowedSaleChannels = ['99food', 'rappi']) => {
  return allowedSaleChannels.includes(canalDeVenda?.toLowerCase());
};